
interface KnowledgeBase {
  title: string;
  titleKey?: string;
  description: string;
  url: string;
}

// Platform Tech Knowledge Bases
export const platformTechKnowledgeBases: KnowledgeBase[] = [
  {
    title: "Blockchain Comparison for iSPAI",
    titleKey: "kb.platformTech.blockchainStrategy",
    description: "Technical specifications and implementation guidelines for blockchain-based attribution systems in AI ecosystems.",
    url: "https://netorgft13770815-my.sharepoint.com/:b:/g/personal/trey_fleming_ispai_io/Ecy3iqvh-WlHs7YDRGuYJKEB_4ap3m3WiNxZGG1sMIRvXA?e=hKrGzK"
  },
  {
    title: "Why Avalanche for iSPAI",
    titleKey: "kb.platformTech.web3Governance",
    description: "Best practices and architectural patterns for integrating various LLM models with existing systems and workflows.",
    url: "https://netorgft13770815-my.sharepoint.com/:b:/g/personal/trey_fleming_ispai_io/EUiIWSI2DkZKu-vOqbJ5aqsBvk_0o7a6nHQ0NHcwbMXmmw?e=CxE45C"
  },
  {
    title: "Why Solana for iSPAI",
    titleKey: "kb.platformTech.defiProtocols",
    description: "Standards and strategies for building robust, scalable API ecosystems that support AI and blockchain technologies.",
    url: "https://netorgft13770815-my.sharepoint.com/:b:/g/personal/trey_fleming_ispai_io/EbA7yRg8VGpEpk4xjno_ef8BGi38rXzuvnnlqc-6o8rYog?e=Vmberg"
  },
  {
    title: "iSPAI Web3 Strategy",
    titleKey: "kb.platformTech.nftMarketplace",
    description: "Implementation guides for developing tools that enable effective collaboration between humans and AI systems.",
    url: "https://netorgft13770815-my.sharepoint.com/:b:/g/personal/trey_fleming_ispai_io/EXpKbJOEMkFIjJF3UesFvTgBe98_H7_YqxhEcUlXyCxEDw?e=mMvSBy"
  },
  {
    title: "iSPAI Security Position",
    titleKey: "kb.platformTech.smartContracts",
    description: "Comprehensive security frameworks and protocols designed specifically for AI-powered applications and services.",
    url: "https://netorgft13770815-my.sharepoint.com/:b:/g/personal/trey_fleming_ispai_io/EQ7ZnOZKOgxDngbi0ZJY0BsB0H8RJk-Uu-_P4S4uVnU-vg?e=e2azan"
  }
];

// Tokenized Ecosystem Knowledge Bases
export const tokenizedEcosystemKnowledgeBases: KnowledgeBase[] = [
  {
    title: "iSPAI Knowledge Base NFT Assignment Agreement",
    titleKey: "kb.tokenizedEco.knowledgeNft",
    description: "Framework for a Smart Contract Focused on a Single Knowledge Base within iSPAI.",
    url: "/lovable-uploads/9e6cec61-5b7d-481a-a48e-c619999223f2.png"
  },
  {
    title: "iSPAI Solution Bounty (SB) Custom Agreement",
    titleKey: "kb.tokenizedEco.solutionBounty",
    description: "Framework for Customized Solution Ownership, Licensing, and Revenue Distribution Based on the Call for Solutions (CfS) Terms.",
    url: "/lovable-uploads/2cc9dcac-e3f1-4e20-9b1b-47e744bdb80e.png"
  }
];

// You can add more knowledge base collections for other domains as needed
